import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';

export const selectedMissionContext = createContext();

function SerialModal(props) {

  const { api, showModal, toggleModal, title, table, addProductToCart, idRow, serial, setSerial, selectedProduct } = props;
  const { tabData, setCart } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);

  const { settingData } = useContext(DataContext);


  useEffect(() => {
    setSerial("");
  }, [showModal]);


  const handleSubmit = () => {
    if (!serial) {
      toast.error('please enter serial')
      return;
    }
    selectedProduct.serial = serial;
    selectedProduct.details = serial;
    addProductToCart(selectedProduct, 1);
    toggleModal();
  }

  return (
    <Modal show={showModal} onHide={toggleModal} className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>Serial Number</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <Row className="mb-4">
          <Col>
            <Form.Control type='text' value={serial}
              onChange={e => setSerial(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { handleSubmit() } }}
              autoFocus />
          </Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={handleSubmit}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default SerialModal;
